import { View } from "@-/com.npmjs.react-native";
import { ToolbarIconButton } from "@-/dev.improve.haniverse.components.ui.toolbar.button.icon";
import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { useOpenLearnMap } from "@-/dev.improve.haniverse.routes.nav.app.learn._lib.map-mode";

/** The cluster's gap between Undo, the map button and Redo. */
const CLUSTER_GAP = 9;

/** Learn's map button between Undo and Redo: a glass circle that opens the map. */
export function LearnToolbarMapButton() {
  const { diameter, isLandscape } = useToolbarGridMetrics();
  const openMap = useOpenLearnMap();
  return (
    <View
      className="items-center justify-center"
      pointerEvents="box-none"
      style={
        isLandscape
          ? { paddingVertical: CLUSTER_GAP, width: diameter }
          : { height: diameter, paddingHorizontal: CLUSTER_GAP }
      }
      testID="learn-toolbar-map-slot"
    >
      <ToolbarIconButton
        accessibilityLabel="Show the map"
        iconSize={20}
        name="MdMap"
        onPress={openMap}
        size="menu"
        testID="learn-map-button"
      />
    </View>
  );
}
